/**
 * 成功案例数据
 * Case studies and success stories
 */

export const caseStudies = [
  {
    id: 'jp-manufacturing-hybrid-cloud',
    slug: 'japan-manufacturing-hybrid-cloud-migration',
    title: {
      zh: '日本制造企业混合云迁移项目',
      en: 'Japan Manufacturing Hybrid Cloud Migration',
      ja: '日本製造企業ハイブリッドクラウド移行プロジェクト',
      ko: '일본 제조기업 하이브리드 클라우드 전환 프로젝트'
    },
    industry: 'manufacturing',
    region: 'JP',
    clientLogo: null, // 如有授权可添加
    clientCompany: {
      zh: '某日本知名汽车零部件制造商',
      en: 'Leading Japanese Auto Parts Manufacturer',
      ja: '日本大手自動車部品メーカー',
      ko: '일본 주요 자동차 부품 제조사'
    },
    thumbnail: '/images/home/successScheme/JapaneseHybridCloud.png',
    summary: {
      zh: '帮助客户完成从传统数据中心到混合云架构的平滑迁移',
      en: 'Smooth migration from traditional data center to hybrid cloud architecture',
      ja: '従来のデータセンターからハイブリッドクラウドアーキテクチャへのスムーズな移行',
      ko: '전통적인 데이터센터에서 하이브리드 클라우드 아키텍처로의 원활한 전환'
    },
    outcomes: [
      {
        metric: 'response_speed',
        label: { zh: '系统响应速度', en: 'System Response Speed', ja: 'システム応答速度', ko: '시스템 응답 속도' },
        improvement: '+40%',
        icon: 'fa-tachometer-alt'
      },
      {
        metric: 'ops_cost',
        label: { zh: '运维成本', en: 'Operation Cost', ja: '運用コスト', ko: '운영 비용' },
        improvement: '-25%',
        icon: 'fa-dollar-sign'
      },
      {
        metric: 'compliance',
        label: { zh: '合规通过率', en: 'Compliance Rate', ja: 'コンプライアンス率', ko: '컴플라이언스 통과율' },
        improvement: '100%',
        icon: 'fa-check-circle'
      }
    ],
    publishDate: '2024-09-15',
    featured: true
  },
  {
    id: 'sg-fintech-data-security',
    slug: 'singapore-fintech-data-security-upgrade',
    title: {
      zh: '新加坡金融科技公司数据安全升级',
      en: 'Singapore Fintech Data Security Upgrade',
      ja: 'シンガポールフィンテック企業データセキュリティアップグレード',
      ko: '싱가포르 핀테크 기업 데이터 보안 고도화'
    },
    industry: 'finance',
    region: 'SG',
    clientLogo: null,
    clientCompany: {
      zh: '新加坡领先的支付服务提供商',
      en: 'Leading Payment Service Provider in Singapore',
      ja: 'シンガポール大手決済サービスプロバイダー',
      ko: '싱가포르 선도 결제 서비스 제공업체'
    },
    thumbnail: '/images/home/successScheme/DataSecurityInSingapore.png',
    summary: {
      zh: '构建多层级数据安全防护体系，满足 MAS 监管要求',
      en: 'Multi-layered data security system meeting MAS regulatory requirements',
      ja: 'MAS規制要件を満たすマルチレイヤーデータセキュリティシステム',
      ko: 'MAS 규제 요건을 충족하는 다층 데이터 보안 체계 구축'
    },
    outcomes: [
      {
        metric: 'security_incidents',
        label: { zh: '安全事件', en: 'Security Incidents', ja: 'セキュリティインシデント', ko: '보안 사고' },
        improvement: '-95%',
        icon: 'fa-shield-alt'
      },
      {
        metric: 'compliance_audit',
        label: { zh: '合规审计通过', en: 'Compliance Audit Pass', ja: 'コンプライアンス監査合格', ko: '컴플라이언스 감사 통과' },
        improvement: '100%',
        icon: 'fa-file-contract'
      },
      {
        metric: 'response_time',
        label: { zh: '威胁响应时间', en: 'Threat Response Time', ja: '脅威対応時間', ko: '위협 대응 시간' },
        improvement: '-60%',
        icon: 'fa-clock'
      }
    ],
    publishDate: '2024-08-20',
    featured: true
  },
  {
    id: 'kr-healthcare-ai-platform',
    slug: 'korea-healthcare-ai-diagnostics-platform',
    title: {
      zh: '韩国医疗机构AI辅助诊断平台',
      en: 'Korea Healthcare AI Diagnostics Platform',
      ja: '韓国医療機関AI診断支援プラットフォーム',
      ko: '한국 의료기관 AI 진단 보조 플랫폼'
    },
    industry: 'healthcare',
    region: 'KR',
    clientLogo: null,
    clientCompany: {
      zh: '韩国某大型综合医院',
      en: 'Major General Hospital in Korea',
      ja: '韓国大型総合病院',
      ko: '한국 대형 종합병원'
    },
    thumbnail: '/images/home/successScheme/KoreanHealthcare.png',
    summary: {
      zh: '部署AI影像分析系统，提升诊断效率和准确率',
      en: 'AI-powered medical imaging analysis system improving diagnostic efficiency',
      ja: 'AI画像解析システム導入による診断効率向上',
      ko: 'AI 영상 분석 시스템 도입으로 진단 효율 향상'
    },
    outcomes: [
      {
        metric: 'diagnostic_accuracy',
        label: { zh: '诊断准确率', en: 'Diagnostic Accuracy', ja: '診断精度', ko: '진단 정확도' },
        improvement: '+35%',
        icon: 'fa-user-md'
      },
      {
        metric: 'processing_time',
        label: { zh: '影像处理时间', en: 'Image Processing Time', ja: '画像処理時間', ko: '영상 처리 시간' },
        improvement: '-70%',
        icon: 'fa-hourglass-half'
      },
      {
        metric: 'patient_satisfaction',
        label: { zh: '患者满意度', en: 'Patient Satisfaction', ja: '患者満足度', ko: '환자 만족도' },
        improvement: '+42%',
        icon: 'fa-smile'
      }
    ],
    publishDate: '2024-07-10',
    featured: true
  },
  {
    id: 'cn-gov-egovernment',
    slug: 'china-government-egovernment-platform',
    title: {
      zh: '中国某地方政府电子政务平台',
      en: 'China Local Government E-Government Platform',
      ja: '中国地方政府電子政務プラットフォーム',
      ko: '중국 지방정부 전자정부 플랫폼'
    },
    industry: 'government',
    region: 'CN',
    clientLogo: null,
    clientCompany: {
      zh: '某省级政府部门',
      en: 'Provincial Government Department',
      ja: '省級政府部門',
      ko: '성급 정부 부처'
    },
    thumbnail: '/images/cases/egovernment.jpg',
    summary: {
      zh: '构建统一的电子政务服务平台，实现跨部门数据共享',
      en: 'Unified e-government service platform with cross-department data sharing',
      ja: '統一電子政務サービスプラットフォームと部門間データ共有',
      ko: '부서 간 데이터 공유를 지원하는 통합 전자정부 서비스 플랫폼'
    },
    outcomes: [
      {
        metric: 'service_efficiency',
        label: { zh: '政务服务效率', en: 'Service Efficiency', ja: '行政サービス効率', ko: '행정 서비스 효율' },
        improvement: '+55%',
        icon: 'fa-rocket'
      },
      {
        metric: 'citizen_satisfaction',
        label: { zh: '市民满意度', en: 'Citizen Satisfaction', ja: '市民満足度', ko: '시민 만족도' },
        improvement: '+48%',
        icon: 'fa-thumbs-up'
      },
      {
        metric: 'paper_reduction',
        label: { zh: '纸质材料减少', en: 'Paper Reduction', ja: '紙書類削減', ko: '종이 문서 감소' },
        improvement: '-80%',
        icon: 'fa-leaf'
      }
    ],
    publishDate: '2024-06-05',
    featured: false
  },
  {
    id: 'hk-retail-omnichannel',
    slug: 'hong-kong-retail-omnichannel-platform',
    title: {
      zh: '香港零售企业全渠道平台',
      en: 'Hong Kong Retail Omnichannel Platform',
      ja: '香港小売企業オムニチャネルプラットフォーム',
      ko: '홍콩 리테일 기업 옴니채널 플랫폼'
    },
    industry: 'retail',
    region: 'HK',
    clientLogo: null,
    clientCompany: {
      zh: '香港知名连锁零售品牌',
      en: 'Leading Retail Chain in Hong Kong',
      ja: '香港大手小売チェーン',
      ko: '홍콩 대표 리테일 체인'
    },
    thumbnail: '/images/home/home-digital-transformation.jpg',
    summary: {
      zh: '打通门店、商城、会员与库存体系，构建全渠道零售运营平台',
      en: 'Unified store, commerce, membership, and inventory operations for omnichannel retail',
      ja: '店舗、EC、会員、在庫を統合したオムニチャネル小売運営基盤',
      ko: '매장, 커머스, 멤버십, 재고를 통합한 옴니채널 리테일 운영 플랫폼'
    },
    outcomes: [
      {
        metric: 'inventory_accuracy',
        label: { zh: '库存准确率', en: 'Inventory Accuracy', ja: '在庫精度', ko: '재고 정확도' },
        improvement: '+32%',
        icon: 'fa-boxes'
      },
      {
        metric: 'repeat_purchase',
        label: { zh: '复购率', en: 'Repeat Purchase Rate', ja: '再購入率', ko: '재구매율' },
        improvement: '+28%',
        icon: 'fa-users'
      },
      {
        metric: 'stock_outs',
        label: { zh: '缺货率', en: 'Stock-out Rate', ja: '欠品率', ko: '품절률' },
        improvement: '-41%',
        icon: 'fa-chart-line'
      }
    ],
    publishDate: '2024-05-18',
    featured: true
  },
  {
    id: 'cn-professional-services-workspace',
    slug: 'china-professional-services-secure-workspace',
    title: {
      zh: '华东咨询机构安全知识协作平台',
      en: 'East China Consulting Secure Knowledge Workspace',
      ja: '華東コンサルティング企業セキュアナレッジワークスペース',
      ko: '화동 컨설팅 기업 보안 지식 협업 플랫폼'
    },
    industry: 'professional',
    region: 'CN',
    clientLogo: null,
    clientCompany: {
      zh: '华东某咨询服务集团',
      en: 'Consulting Services Group in East China',
      ja: '華東地域コンサルティングサービスグループ',
      ko: '화동 지역 컨설팅 서비스 그룹'
    },
    thumbnail: '/images/coreService/service-email-sorting.jpg',
    summary: {
      zh: '构建安全文档协作、项目计费和知识沉淀一体化工作平台',
      en: 'Secure collaboration, project billing, and knowledge capture in one workspace',
      ja: '安全な文書協業、工数請求、ナレッジ蓄積を統合したワークスペース',
      ko: '보안 협업, 프로젝트 청구, 지식 축적을 통합한 워크스페이스'
    },
    outcomes: [
      {
        metric: 'retrieval_speed',
        label: { zh: '文档检索效率', en: 'Document Retrieval Speed', ja: '文書検索速度', ko: '문서 검색 효율' },
        improvement: '+68%',
        icon: 'fa-folder-open'
      },
      {
        metric: 'billable_hours',
        label: { zh: '可计费工时采集率', en: 'Billable Hour Capture', ja: '請求可能工数取得率', ko: '청구 가능 시간 확보율' },
        improvement: '+22%',
        icon: 'fa-clock'
      },
      {
        metric: 'onboarding_cycle',
        label: { zh: '客户入场周期', en: 'Client Onboarding Cycle', ja: '顧客オンボーディング期間', ko: '고객 온보딩 기간' },
        improvement: '-45%',
        icon: 'fa-user-check'
      }
    ],
    publishDate: '2024-03-28',
    featured: true
  },
  {
    id: 'tw-education-cloud',
    slug: 'taiwan-education-cloud-learning-platform',
    title: {
      zh: '台湾教育机构云端学习平台',
      en: 'Taiwan Education Cloud Learning Platform',
      ja: '台湾教育機関クラウド学習プラットフォーム',
      ko: '대만 교육기관 클라우드 학습 플랫폼'
    },
    industry: 'education',
    region: 'TW',
    clientLogo: null,
    clientCompany: {
      zh: '台湾某知名大学',
      en: 'Renowned University in Taiwan',
      ja: '台湾有名大学',
      ko: '대만 유명 대학'
    },
    thumbnail: '/images/cases/education-cloud.jpg',
    summary: {
      zh: '部署在线教育平台，支持大规模远程教学',
      en: 'Online education platform supporting large-scale remote teaching',
      ja: '大規模遠隔教育を支援するオンライン教育プラットフォーム',
      ko: '대규모 원격 수업을 지원하는 온라인 교육 플랫폼'
    },
    outcomes: [
      {
        metric: 'concurrent_users',
        label: { zh: '并发用户数', en: 'Concurrent Users', ja: '同時接続ユーザー数', ko: '동시 접속 사용자 수' },
        improvement: '10,000+',
        icon: 'fa-user-graduate'
      },
      {
        metric: 'system_uptime',
        label: { zh: '系统正常运行时间', en: 'System Uptime', ja: 'システム稼働時間', ko: '시스템 가동 시간' },
        improvement: '99.9%',
        icon: 'fa-server'
      },
      {
        metric: 'learning_engagement',
        label: { zh: '学习参与度', en: 'Learning Engagement', ja: '学習参加率', ko: '학습 참여도' },
        improvement: '+52%',
        icon: 'fa-book-reader'
      }
    ],
    publishDate: '2024-04-25',
    featured: false
  }
];

// 按行业分组
export const caseStudiesByIndustry = {
  finance: caseStudies.filter(c => c.industry === 'finance'),
  healthcare: caseStudies.filter(c => c.industry === 'healthcare'),
  manufacturing: caseStudies.filter(c => c.industry === 'manufacturing'),
  government: caseStudies.filter(c => c.industry === 'government'),
  retail: caseStudies.filter(c => c.industry === 'retail'),
  professional: caseStudies.filter(c => c.industry === 'professional'),
  education: caseStudies.filter(c => c.industry === 'education')
};

// 按地区分组
export const caseStudiesByRegion = {
  CN: caseStudies.filter(c => c.region === 'CN'),
  HK: caseStudies.filter(c => c.region === 'HK'),
  TW: caseStudies.filter(c => c.region === 'TW'),
  JP: caseStudies.filter(c => c.region === 'JP'),
  KR: caseStudies.filter(c => c.region === 'KR'),
  SG: caseStudies.filter(c => c.region === 'SG')
};

// 获取精选案例
export const featuredCaseStudies = caseStudies.filter(c => c.featured);

export default caseStudies;
